/*
 * Project: LegalPlace assistant
 * File: src\logic\section.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


import { OptionWrapper } from './option_wrapper';
import { LABEL, OPTS } from './lp_map_utils';
// TODO: add more option names here
export class Section {
    id = 0;
    label = "";
    options = [];
    options_extracted = []
    constructor( obj ) {
            // TODO: Check if the thing is null or not
            this.id = obj['id']
            this.label = obj[LABEL]
            this.options = obj[OPTS];
        }
        // lazy loading for options
    loadFenyan( opts_ref, vars_ref ) {
        // Some optimization
        var opts = this.options;
        // load
        for ( var i in opts ) {
            var tmp_opt_id = opts[i];
            var tmp_opt = new OptionWrapper( opts_ref[tmp_opt_id] );
            tmp_opt.loadFenyanVariables( vars_ref );
            this.options_extracted[i] = tmp_opt;
        }
    }
}


// WEBPACK FOOTER //
// ./src/logic/section.js